/**
 * Created by Ethan on 17/1/13.
 */

import { CMS_SERVER_HOST, WMS_DATA_SERVER_HOST, WMS_SERVER_HOST } from '../../constants/Profile';

export const searchZoneListWithRelation = WMS_SERVER_HOST + "/openAPI/wms/zones/queriesWithRelation";

// export const searchCoordinateZoneList = WMS_SERVER_HOST + "/wms/zones/coordinateZones";

// export const searchProposalGroupList = WMS_SERVER_HOST + "/wms/proposalGroups/queries";
//指定方案组
export const getProposalGroup = WMS_SERVER_HOST + "/openAPI/wms/proposalGroups/{id}";
export const getAdZoneByProposalGroupId = WMS_SERVER_HOST + "/openAPI/wms/proposalGroups/{id}/adZoneList";

//指定商机
export const getProposalGroupByBusinessId = WMS_SERVER_HOST + "/wms/businessOpportunity/{id}/proposal/group";

// export const getOSSPolicyPublic = WMS_SERVER_HOST + "/openAPI/wms/businessIntentions/ftp/oss/policy";

export const getProposal = WMS_SERVER_HOST + "/openAPI/wms/proposals/{id}";
//指定商机获取带看list
// export const searchOpportunitySchedulers = WMS_SERVER_HOST + "/wms/businessOpportunity/{id}/schedulers";
export const getOpportunityScheduler = WMS_SERVER_HOST + "/openAPI/wms/businessSchedulers/{id}";
export const getBusinessSchedulerByOpportunityId = WMS_SERVER_HOST + "/wms/businessOpportunity/{id}/schedulers";
export const getBusinessSchedulerListByTableKey = WMS_SERVER_HOST + "/wms/businessSchedulers/byTableKey/{tableKey}";

//获取房源列表
// export const searchZoneList = WMS_SERVER_HOST + "/openAPI/wms/zones/queries";
export const searchZoneList = WMS_SERVER_HOST + "/openAPI/homepage/zone/queryZoneList";
export const searchZoneListIntercept = WMS_SERVER_HOST + "/wms/zones/queries";
export const getZoneContacts = WMS_SERVER_HOST + "/wms/zones/{id}/contacts?classify={classify}";

// export const getZone = WMS_SERVER_HOST + "/openAPI/wms/zones/{id}";
export const getZone = WMS_SERVER_HOST + '/openAPI/wms/zones/zonesDetail/{id}'
export const createZone = WMS_SERVER_HOST + "/wms/zones";
export const updateZone = WMS_SERVER_HOST + "/wms/zones/{id}";
export const getZoneBuildingList = WMS_SERVER_HOST + "/wms/zones/{id}/buildings";
export const updateZoneAddVacantAreaFollowup = WMS_SERVER_HOST + "/wms/zones/{id}/addEmptyVacantAreaFollowup";

export const updateBuilding = WMS_SERVER_HOST + "/wms/buildings/{id}";
export const getBuilding = WMS_SERVER_HOST + "/wms/buildings/{id}";
export const createBuilding = WMS_SERVER_HOST + "/wms/buildings";

export const getFollowup = WMS_SERVER_HOST + "/wms/followups/{id}";
export const searchFollowup = WMS_SERVER_HOST + "/wms/followups/queries";
export const createFollowup = WMS_SERVER_HOST + "/wms/followups";
export const updateFollowup = WMS_SERVER_HOST + "/wms/followups/{id}";
export const deleteFollowup = WMS_SERVER_HOST + "/wms/followups/{id}";

//跟进的下一步任务
export const createToDo = WMS_SERVER_HOST + "/wms/todos";
export const getToDo = WMS_SERVER_HOST + "/wms/todos/{id}";
export const searchToDo = WMS_SERVER_HOST + "/wms/todos/queries";
export const updateToDo = WMS_SERVER_HOST + "/wms/todos/{id}";
export const deleteToDo = WMS_SERVER_HOST + "/wms/todos/{id}";
export const searchToDoByTableKey = WMS_SERVER_HOST + "/wms/todos/byTableKey/{tableKey}";

export const getMyWaitReadToDoStatusCount = WMS_SERVER_HOST + "/wms/todoStatus/myWaitReadCount";
export const getToDoStatus = WMS_SERVER_HOST + "/wms/todoStatus/{id}";
export const updateToDoStatus = WMS_SERVER_HOST + "/wms/todoStatus/{id}";
export const deleteToDoStatus = WMS_SERVER_HOST + "/wms/todoStatus/{id}";
export const acceptToDoStatus = WMS_SERVER_HOST + "/wms/todoStatus/{id}/accept";

export const searchToDoStatus = WMS_SERVER_HOST + "/wms/todoStatus/queries";
export const myPendingQueries = WMS_SERVER_HOST + "/wms/todoStatus/myPendingQueries";


export const searchContact = WMS_SERVER_HOST + "/wms/contacts/queries";
export const getContact = WMS_SERVER_HOST + "/wms/contacts/{id}";

export const createContact = WMS_SERVER_HOST + "/wms/contacts";
export const updateContact = WMS_SERVER_HOST + "/wms/contacts/{id}";
export const deleteContact = WMS_SERVER_HOST + "/wms/contacts/{id}";
export const searchContactZones = WMS_SERVER_HOST + "/wms/contacts/{id}/zones";
export const addContactZones = WMS_SERVER_HOST + "/wms/contacts/{id}/zones";
export const deleteContactZone = WMS_SERVER_HOST + "/wms/contacts/{id}/zones/{zoneId}";


export const searchBrand = WMS_SERVER_HOST + "/wms/brands/queries";
export const createBrand = WMS_SERVER_HOST + "/wms/brands";
export const updateBrand = WMS_SERVER_HOST + "/wms/brands/{id}";
export const deleteBrand = WMS_SERVER_HOST + "/wms/brands/{id}";
export const beforeBrandDelete = WMS_SERVER_HOST + "/wms/brands/{id}/beforeDelete";



export const createZoneContacts = WMS_SERVER_HOST + "/wms/zones/{id}/contacts";
export const updateZoneContacts = WMS_SERVER_HOST + "/wms/zones/{id}/contacts/{contactsId}";
export const deleteZoneContacts = WMS_SERVER_HOST + "/wms/zones/{id}/contacts/{contactsId}";


export const getZoneDistrictTotal = WMS_SERVER_HOST + "/openAPI/wms/zoneSummary/summaryDistrict";
// export const getCountiesByCityName = WMS_SERVER_HOST + "/openAPI/district/counties?cityName={cityName}";
export const getCountiesByCityName = WMS_SERVER_HOST + "/openAPI/wms/district/counties?cityName={cityName}";



export const getZoneCount = WMS_SERVER_HOST + "/openAPI/wms/zones/queriesZonesCount";
export const searchBrandList = WMS_SERVER_HOST + "/openAPI/wms/brands/lessorAll";
export const getDistrictTownList = WMS_SERVER_HOST + "/openAPI/wms/district/townAll";
export const addZoneBrowsingHistories = WMS_DATA_SERVER_HOST + "/openAPI/wms/zoneBrowsingHistories/create";

export const classifyRecommendApi =
  WMS_SERVER_HOST + '/openAPI/homepage/zone/classifyRecommend'


//查询案例视频类型(成交租户类型)
export const queryCaseTypeApi =
  WMS_SERVER_HOST + '/openAPI/homepage/index/queryCaseType'

//查询案例视频分页数据
export const queryCaseApi =
  WMS_SERVER_HOST + '/openAPI/homepage/index/queryCase'

export const getSearchConditionDictApi =
  WMS_SERVER_HOST + '/openAPI/homepage/zone/getSearchConditionDict'


// 个人收藏列表
export const favoriteListApi =
  WMS_SERVER_HOST + '/openAPI/homepage/favoriteList'

// 添加收藏列表
export const addFavoriteApi =
  WMS_SERVER_HOST + '/openAPI/homepage/addFavorite'

// 取消收藏列表
export const cancelFavoriteApi =
  WMS_SERVER_HOST + '/openAPI/homepage/cancelFavorite'

export const verifyFavoriteApi =
  WMS_SERVER_HOST + '/openAPI/homepage/verifyFavorite'

export const homeSearchApi =
  WMS_SERVER_HOST + '/openAPI/homepage/index/search'

export const InfoCenterListAPI = `${CMS_SERVER_HOST}/openAPI/cms/content/list`
// channelCode=INFORMATION_CENTER&currentPage=${page}&pageSize=10`

export const ArticleDetailsApi = `${CMS_SERVER_HOST}/openAPI/cms/content/detail`
